module.exports = __webpack_public_path__ + "img/Boss-3.17032fc7.png";